import Vue from "vue";

Vue.prototype.$style = {
  inputBox: {
    mandatory: "#ffcece",
  },
  card: {
    background: "#F6F9FC",
    action: "#FFFFFF",
    header: "white",
  },
  maincolor: "#41CAC6",
  tag: {
    body: "#C3EBE9",
    text: "#316361",
  },
  button: {
    body: "#397FC3",
    text: "#FFFFFF",
  },
  table: {
    header: "#f8fdfd",
  },
  entryBar: {
    body: "#f8fdfd",
  },
  ordering: {
    menu: {
      group: "white",
      item: {
        even: "#E8E2F2",
        odd: "#D9CBEF",
      },
      choice: {
        even: "#F7F7F8",
        odd: "#E3E8EE",
      },
    },
    item: "#41CAC6",
    label: "#397FC3",
  },
}
